

const getLanguageName = (languagePool, languageKey) => {
  const { label = languageKey } = languagePool.find((pool) => pool.key === languageKey) || {};
  return label;
};

export { getLanguageName };